import React from 'react';
import {
  TableRow,
  TableCell,
  Box,
  useTheme,
  alpha,
  Skeleton
} from '@mui/material';

const ApiKeyRowSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <TableRow
      sx={{
        backgroundColor: `${alpha(theme.palette.background.default, 0.4)} !important`,
      }}
    >
      <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
        <Skeleton variant="text" width={40} height={24} />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" width={150} height={24} />
      </TableCell>
      <TableCell align="center">
        <Box sx={{ display: 'inline-flex' }}>
          <Skeleton variant="circular" width={24} height={24} />
        </Box>
      </TableCell>
      <TableCell>
        <Skeleton variant="text" width={100} height={20} />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" width={100} height={20} />
      </TableCell>
      <TableCell align="center">
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Skeleton variant="circular" width={32} height={32} />
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default ApiKeyRowSkeleton;
